import angular from 'angular'
import uiRouter from '@uirouter/angularjs'
import uiMask from 'angular-ui-mask'
import ngFileUpload from 'ng-file-upload'
import ngTranslate from 'angular-translate'
import 'angular-translate-loader-static-files/angular-translate-loader-static-files'
import ngCookies from 'angular-cookies'
import ocLazyLoad from 'oclazyload'
import './../assets/custom_components/ng-rollbar/ng-rollbar'

import { UdsModalService } from './services/uds-modal.service'
import { confirmationModalService } from './services/confirmation-modal.service'
import { assetPreviewService } from './services/asset-preview.service'
import { assetService } from './services/asset.service'
import { billingService } from './services/billing.service'
import { featureReleaseNotificationsService } from './services/feature-release-notifications.service'
import { attachmentService } from './services/attachment.service'
import { auditBaseService } from './services/audit-base.service'
import { authInterceptor } from './services/auth-interceptor.service'
import { avatarService } from './services/avatar.service'
import { backendErrorParserService } from './services/backend-error-parser.service'
import { brandBaseService } from './services/brand-base.service'
import { cacheService } from './services/cache.service'
import { requestDeduplicationService } from './services/request-deduplication.service'
import { connectorWebService } from './services/connector-web.service'
import { constantsService } from './services/constants.service'
import { dataService } from './services/data.service'
import { emojisService } from './services/emojis.service'
import { eventListenerService } from './services/event-listener.service'
import { fontsBaseService } from './services/fonts-base.service'
import { groupService } from './services/group.service'
import { headerFilterService } from './services/header-filter.service'
import { initializerService } from './services/initializer.service'
import { integrationRegisterService } from './services/integration-register.service'
import { integrationStoreService } from './services/integration-store.service'
import { intercomService } from './services/intercom.service'
import { languageService } from './services/language.service'
import { messageService } from './services/message.service'
import { modalService } from './services/modal.service'
import { notificationsCentralService } from './services/notifications-central.service'
import { notificationsService } from './services/notifications.service'
import { rollbarService } from './services/rollbar.service'
import { savedRepliesService } from './services/saved-replies.service'
import { segmentService } from './services/segment.service'
import { sliderService } from './services/slider.service'
import { socketService } from './services/socket.service'
import { templateService } from './services/template.service'
import { temporaryFileService } from './services/temporary-file.service'
import { trixEditorService } from './services/trix-editor.service'
import { uiElementViewLogService } from './services/uiElementViewLog.service.js'
import { uploadService } from './services/upload.service'
import { utils } from './services/utils.service'
import { validationService } from './services/validation.service'
import { vitallyService } from './services/vitally.service'
import { localStorageService } from './services/local-storage.service'
import { mimeService } from './services/mime.service'
import { coreFilters } from './directives/core-filters/core-filters.directive'
import { header } from './directives/header/header.directive'
import { toastService } from './services/toast.service'
import { bannerService } from './services/banner.service'
import { newAssetService } from './services/new-asset.service'
import { uploadQueueService } from './services/upload-queue.service'
import { multipartUploadService } from './services/multipart-upload.service'
import { stackService } from './services/stack.service'
import { modalStackService } from './services/modal-stack.service'
import { campaignService } from './services/campaigns.service.js'
import { campaignActionsService } from './services/campaign-actions.service.js'
import { assetThumbnailGeneratorService } from './services/asset-thumbnail-generator.service'
import { wideService } from './services/wide.service.js'
import { commentReactionsService } from './services/comment-reactions.js'
import { campaignInitialOnboardingService } from './services/campaign-initial-onboarding.service'
import { onboardingDialogService } from './services/onboarding-dialog.service'
import { companyService } from './services/company.service'
import { userFiltersService } from './services/user-filters.service'

import { warningMessageDialog } from './dialogs/warning-message/warning-message-dialog.directive'
import { addToGroupsDialog } from './dialogs/add-to-groups/add-to-groups-dialog.directive'
import { changePasswordDialog } from './dialogs/change-password/change-password-dialog.directive'
import { warningSaveDiscardDialog } from './dialogs/warning-save-discard/warning-save-discard-dialog.directive'

import { assetPreviewDialog } from './dialogs/asset-preview-dialog/asset-preview-dialog.directive'
import { assetQuickPreviewDialog } from './dialogs/asset-quick-preview-dialog/asset-quick-preview-dialog.directive'
import { modulesPricingDialog } from './dialogs/modules-pricing/modules-pricing-dialog.directive'
import { pricingFeedbackDialog } from './dialogs/pricing-feedback/pricing-feedback-dialog.directive'

import { advancedSearch } from './directives/advanced-search/advanced-search.directive'
import { advancedSearchFilters } from './directives/advanced-search-filters/advanced-search-filters.directive'
import { advancedFiltersCustomFields } from './directives/advanced-filters-custom-fields/advanced-filters-custom-fields.directive.js'
import { advancedSearchDropdown } from './directives/advanced-search-dropdown/advanced-search-dropdown.directive'
import { assetPreviewHeader } from './directives/asset-preview-header/asset-preview-header.directive'
import { assetPreviewVersionControl } from './directives/asset-preview-version-control/asset-preview-version-control.directive'
import { assetPreviewNavigation } from './directives/asset-preview-navigation/asset-preview-navigation.directive'
import { assetPreviewAudio } from './directives/asset-preview-audio/asset-preview-audio.directive'
import { assetPreviewImage } from './directives/asset-preview-image/asset-preview-image.directive'
import { assetPreviewPdf } from './directives/asset-preview-pdf/asset-preview-pdf.directive'
import { assetPreviewVideo } from './directives/asset-preview-video/asset-preview-video.directive'
import { assetPreviewUnavailable } from './directives/asset-preview-unavailable/asset-preview-unavailable.directive'
import { assetPreviewFolder } from './directives/asset-preview-folder/asset-preview-folder.directive'
import { assetPreviewTabs } from './directives/asset-preview-tabs/asset-preview-tabs.directive'
import { assetPreviewTabsUser } from './directives/asset-preview-tabs-user/asset-preview-tabs-user.directive'
import { assetPreviewTabInstructions } from './directives/asset-preview-tab-instructions/asset-preview-tab-instructions.directive'
import { assetPreviewTabInfo } from './directives/asset-preview-tab-info/asset-preview-tab-info.directive'
import { assetPreviewTabUsage } from './directives/asset-preview-tab-usage/asset-preview-tab-usage.directive'
import { assetPreviewTabComments } from './directives/asset-preview-tab-comments/asset-preview-tab-comments.directive'
import { chatMessageDirective } from './directives/chat-message/chat-message.directive'
import { assetPreviewTags } from './directives/asset-preview-tags/asset-preview-tags.directive'
import { assetPreviewTagsEmptyMode } from './directives/asset-preview-tags/components/asset-preview-tags-empty-mode.directive.js'
import { assetPreviewTabActivities } from './directives/asset-preview-tab-activities/asset-preview-tab-activities.directive'
import { assetPreviewTabResults } from './directives/asset-preview-tab-results/asset-preview-tab-results.directive'
import { assetPreviewTabResultsPosts } from './directives/asset-preview-tab-results-posts/asset-preview-tab-results-posts.directive'
import { assetPreviewApprovalButtons } from './directives/asset-preview-approval-buttons/asset-preview-approval-buttons.directive'
import { approvalMessageModal } from './directives/approval-message-modal/approval-message-modal.directive'
import { emptyState } from './directives/empty-state/empty-state.directive'
import { inputRichText } from './directives/input-rich-text/input-rich-text.directive'
import { chat } from './directives/chat/chat.directive'
import { messageReactions } from './directives/message-reactions/message-reactions.directive'
import { stackedProgressBar } from './directives/stacked-progress-bar/stacked-progress-bar.directive'
import { approvalMessage } from './directives/approval-message/approval-message.directive.js'
import { annotationPin } from './directives/annotation-pin/annotation-pin.directive.js'
import { taskListItem } from './directives/task-list-item/task-list-item.directive.js'
import { approvalListItem } from './directives/approval-list-item/approval-list-item.directive'
import { shareArtButton } from './directives/share-art-button/share-art-button.directive'
import { CommentReactionItemDirective } from './directives/comment-reaction-item/comment-reaction-item.directive'
import { floatingBarDelete } from './directives/floating-bar-delete/floating-bar-delete.directive'

import { sidebarCompanySelect } from './directives/sidebar-company-select/sidebar-company-select.directive'
import { sidebarMenu } from './directives/sidebar-menu/sidebar-menu.directive'
import { sidebarMenuGuest } from './directives/sidebar-menu-guest/sidebar-menu-guest.directive.js'
import { headerRepository } from './directives/header-repository/header-repository.directive'
import { repositoryFilters } from './../repository/directives/repository-filters/repository-filters.directive'
import { appBannerModalDirective } from './dialogs/app-banner-modal/app-banner-modal.directive'
import { copyGuestLinkDirective } from './directives/copy-guest-link/copy-guest-link.directive'
import { accessList } from './directives/access-list/access-list.directive'
import { sharedPacksHeader } from './directives/shared-packs-header/shared-packs-header.directive'
import { advancedFilter } from './directives/advanced-filter/advanced-filter.directive'

import { manageUserStatusDialog } from './dialogs/manage-user-status/manage-user-status-dialog.directive'
import { manageGuestStatusDialog } from './dialogs/manage-guest-status/manage-guest-status-dialog.directive'
import { upgradeCompanyPlanDialog } from './dialogs/upgrade-company-plan/upgrade-company-plan-dialog.directive'
import { planUpgradeConfirmationDialog } from './dialogs/plan-upgrade-confirmation/plan-upgrade-confirmation-dialog.directive'
import { cropImageDialog } from './dialogs/crop-image/crop-image-dialog.directive'
import { askForSupportDialog } from './dialogs/ask-for-support/ask-for-support-dialog.directive'
import { confirmationDialog } from './dialogs/confirmation-dialog/confirmation-dialog.directive'
import { inputRichTextLinkDialog } from './dialogs/input-rich-text-link/input-rich-text-link-dialog.directive'
import { shareWithGuestsDialog } from './dialogs/share-with-guests/share-with-guests-dialog.directive'
import { permissionsSettings } from './dialogs/permissions-settings/permissions-settings-dialog.directive'
import { assetPackAccess } from './dialogs/asset-pack-access/asset-pack-access-dialog.directive'
import { updateAccessExpirationDateDialog } from './dialogs/update-access-expiration-date/update-access-expiration-date-dialog.directive'
import { deleteAssetPackDialog } from './dialogs/delete-asset-pack/delete-asset-pack-dialog.directive'
import { onboardingTwoFeatureDialog } from './dialogs/onboarding-two-feature/onboarding-two-feature-dialog.directive'
import { onboardingDialog } from './dialogs/onboarding-dialog/onboarding-dialog.directive'

import { formattedDateFromNow } from './filters/formatted-date-from-now.filter'
import { formattedDateMedium } from './filters/formatted-date-medium.filter'
import { formattedFileSize } from './filters/formatted-file-size.filter'
import { formattedHashtag } from './filters/formatted-hashtag.filter'
import { formattedRoleFilter } from './filters/formatted-role.filter'
import { truncateText } from './filters/truncate-text.filter'
import { trusted } from './filters/trusted.filter'
import { urlify } from './filters/urlify.filter'
import { formattedDateDayMonth } from './filters/formatted-date-day-month.filter'

import { emptyListMessage } from './components/empty-list-message/empty-list-message.component'
import { priorityBadge } from './components/priority-badge/priority-badge.component'
import { circleLoader } from './components/svg-circle-loader/svg-circle-loader.component'
import { uploadFile } from './components/upload-file/upload-file.component'
import { uploadTable } from './components/upload-table/upload-table.component'
import { sharedPackItem } from './components/shared-pack-item/shared-pack-item.component'
import { sharedPackStatus } from './components/shared-pack-status/shared-pack-status.component'

import { analyticsService } from '../analytics/services/analytics.service'
import { analyticsInsightsPopup } from '../analytics/directives/analytics-insights-popup/analytics-insights-popup.directive'
import { analyticsInsightsCard } from '../analytics/directives/analytics-insights-card/analytics-insights-card.directive'
import { analyticsSkeletonLoader } from '../analytics/directives/analytics-skeleton-loader/analytics-skeleton-loader.directive'

import { bindCampaignDialog } from './dialogs/bind-campaign/bind-campaign-dialog.directive'
import { inputSelectCampaign } from './directives/input-select-campaign/input-select-campaign.directive'

import { renderVideoDialog } from './dialogs/render-video/render-video-dialog.directive'
import { warningCaption } from './directives/warning-caption/warning-caption.directive'
import { userActionCard } from './directives/user-action-card/user-action-card.directive'
import { dragAndDrop } from './directives/drag-and-drop/drag-and-drop.directive'

// Mia
import { miaLandingPageLayout } from './directives/mia-layout/mia-layout.directive'

const module = angular
  .module('deskfy.core', [
    /*
     * 3rd Party modules
     */
    uiRouter,
    'ui.sortable',
    uiMask,
    ngFileUpload,
    ngCookies,
    'ngAvatar',
    ngTranslate,
    'moment-picker',
    'angularTrix',
    'angular-content-editable',
    'angularLazyImg',
    'uiCropper',
    'pasvaz.bindonce',
    'tandibar/ng-rollbar',
    ocLazyLoad
  ])
  .factory('AssetService', assetService)
  .factory('BillingService', billingService)
  .factory('FeatureReleaseNotificationsService', featureReleaseNotificationsService)
  .factory('AttachmentService', attachmentService)
  .factory('AuditBaseService', auditBaseService)
  .factory('AuthInterceptor', authInterceptor)
  .factory('AvatarService', avatarService)
  .factory('BackendErrorParserService', backendErrorParserService)
  .factory('BrandBaseService', brandBaseService)
  .factory('CacheService', cacheService)
  .factory('RequestDeduplicationService', requestDeduplicationService)
  .factory('ConnectorWebService', connectorWebService)
  .factory('CONSTANTS', constantsService)
  .factory('DataService', dataService)
  .factory('EmojisService', emojisService)
  .factory('EventListenerService', eventListenerService)
  .factory('FontsBaseService', fontsBaseService)
  .factory('GroupService', groupService)
  .factory('HeaderFilterService', headerFilterService)
  .factory('InitializerService', initializerService)
  .factory('IntegrationRegisterService', integrationRegisterService)
  .factory('IntegrationStoreService', integrationStoreService)
  .factory('IntercomService', intercomService)
  .factory('LanguageService', languageService)
  .factory('MessageService', messageService)
  .factory('ModalService', modalService)
  .factory('NotificationsCentralService', notificationsCentralService)
  .factory('NotificationsService', notificationsService)
  .factory('RollbarService', rollbarService)
  .factory('SavedRepliesService', savedRepliesService)
  .factory('SegmentService', segmentService)
  .factory('SliderService', sliderService)
  .factory('SocketService', socketService)
  .factory('TemplateService', templateService)
  .factory('TemporaryFileService', temporaryFileService)
  .factory('TrixEditorService', trixEditorService)
  .factory('UploadService', uploadService)
  .factory('ToastService', toastService)
  .factory('BannerService', bannerService)
  .factory('NewAssetService', newAssetService)
  .factory('ModalStackService', modalStackService)
  .factory('Utils', utils)
  .factory('ValidationService', validationService)
  .factory('VitallyService', vitallyService)
  .factory('AssetPreviewService', assetPreviewService)
  .factory('UdsModalService', UdsModalService.create)
  .factory('UiElementViewLogService', uiElementViewLogService)
  .factory('ConfirmationModalService', confirmationModalService)
  .factory('LocalStorageService', localStorageService)
  .factory('UploadQueueService', uploadQueueService)
  .factory('MultipartUploadService', multipartUploadService)
  .factory('StackService', stackService)
  .factory('CampaignService', campaignService)
  .factory('CampaignActionService', campaignActionsService)
  .factory('AssetThumbnailGeneratorService', assetThumbnailGeneratorService)
  .factory('WideService', wideService)
  .factory('CommentReactionsService', commentReactionsService)
  .factory('CampaignInitialOnboardingService', campaignInitialOnboardingService)
  .factory('OnboardingDialogService', onboardingDialogService)
  .factory('MimeService', mimeService)
  .factory('CompanyService', companyService)
  .factory('UserFilterService', userFiltersService)
  .filter('formattedDateFromNow', formattedDateFromNow)
  .filter('formattedDateMedium', formattedDateMedium)
  .filter('formattedFileSize', formattedFileSize)
  .filter('formattedHashtag', formattedHashtag)
  .filter('formattedRole', formattedRoleFilter)
  .filter('truncateText', truncateText)
  .filter('trusted', trusted)
  .filter('urlify', urlify)
  .filter('formattedDateDayMonth', formattedDateDayMonth)
  .controller('BasicModalController', function () {})
  .component('emptyListMessage', emptyListMessage)
  .component('priorityBadge', priorityBadge)
  .component('circleLoader', circleLoader)
  .component('uploadFile', uploadFile)
  .component('uploadTable', uploadTable)
  .component('sharedPackItem', sharedPackItem)
  .component('sharedPackStatus', sharedPackStatus)
  .directive('coreFilters', coreFilters)
  .directive('warningMessageDialog', warningMessageDialog)
  .directive('addToGroupsDialog', addToGroupsDialog)
  .directive('changePasswordDialog', changePasswordDialog)
  .directive('manageUserStatusDialog', manageUserStatusDialog)
  .directive('manageGuestStatusDialog', manageGuestStatusDialog)
  .directive('upgradeCompanyPlanDialog', upgradeCompanyPlanDialog)
  .directive('planUpgradeConfirmationDialog', planUpgradeConfirmationDialog)
  .directive('cropImageDialog', cropImageDialog)
  .directive('renderVideoDialog', renderVideoDialog)
  .directive('askForSupportDialog', askForSupportDialog)
  .directive('confirmationDialog', confirmationDialog)
  .directive('inputRichTextLinkDialog', inputRichTextLinkDialog)
  .directive('assetPreviewImage', assetPreviewImage)
  .directive('assetPreviewPdf', assetPreviewPdf)
  .directive('assetPreviewVideo', assetPreviewVideo)
  .directive('assetPreviewDialog', assetPreviewDialog)
  .directive('assetQuickPreviewDialog', assetQuickPreviewDialog)
  .directive('assetPreviewHeader', assetPreviewHeader)
  .directive('assetPreviewVersionControl', assetPreviewVersionControl)
  .directive('assetPreviewNavigation', assetPreviewNavigation)
  .directive('assetPreviewAudio', assetPreviewAudio)
  .directive('assetPreviewUnavailable', assetPreviewUnavailable)
  .directive('assetPreviewFolder', assetPreviewFolder)
  .directive('assetPreviewTabs', assetPreviewTabs)
  .directive('assetPreviewTabsUser', assetPreviewTabsUser)
  .directive('assetPreviewTabInstructions', assetPreviewTabInstructions)
  .directive('assetPreviewTabInfo', assetPreviewTabInfo)
  .directive('assetPreviewTags', assetPreviewTags)
  .directive('assetPreviewTagsEmptyMode', assetPreviewTagsEmptyMode)
  .directive('assetPreviewTabActivities', assetPreviewTabActivities)
  .directive('assetPreviewTabResults', assetPreviewTabResults)
  .directive('assetPreviewTabResultsPosts', assetPreviewTabResultsPosts)
  .directive('assetPreviewApprovalButtons', assetPreviewApprovalButtons)
  .directive('approvalMessageModal', approvalMessageModal)
  .directive('emptyState', emptyState)
  .directive('inputRichText', inputRichText)
  .directive('chat', chat)
  .directive('messageReactions', messageReactions)
  .directive('assetPreviewTabComments', assetPreviewTabComments)
  .directive('assetPreviewTabUsage', assetPreviewTabUsage)
  .directive('bindCampaignDialog', bindCampaignDialog)
  .directive('inputSelectCampaign', inputSelectCampaign)
  .directive('warningSaveDiscard', warningSaveDiscardDialog)
  .directive('modulesPricingDialog', modulesPricingDialog)
  .directive('pricingFeedbackDialog', pricingFeedbackDialog)
  .directive('shareWithGuestsDialog', shareWithGuestsDialog)
  .directive('updateAccessExpirationDateDialog', updateAccessExpirationDateDialog)
  .directive('deleteAssetPackDialog', deleteAssetPackDialog)
  .directive('permissionsSettings', permissionsSettings)
  .directive('assetPackAccess', assetPackAccess)
  .directive('accessList', accessList)
  .directive('sharedPacksHeader', sharedPacksHeader)
  .factory('AnalyticsService', analyticsService)
  .directive('analyticsInsightsPopup', analyticsInsightsPopup)
  .directive('analyticsInsightsCard', analyticsInsightsCard)
  .directive('analyticsSkeletonLoader', analyticsSkeletonLoader)
  .directive('sidebarCompanySelect', sidebarCompanySelect)
  .directive('sidebarMenu', sidebarMenu)
  .directive('sidebarMenuGuest', sidebarMenuGuest)
  .directive('advancedSearch', advancedSearch)
  .directive('advancedSearchFilters', advancedSearchFilters)
  .directive('advancedFiltersCustomFields', advancedFiltersCustomFields)
  .directive('advancedSearchDropdown', advancedSearchDropdown)
  .directive('header', header)
  .directive('headerRepository', headerRepository)
  .directive('repositoryFilters', repositoryFilters)
  .directive('appBannerModalController', appBannerModalDirective)
  .directive('chatMessage', chatMessageDirective)
  .directive('stackedProgressBar', stackedProgressBar)
  .directive('approvalMessage', approvalMessage)
  .directive('annotationPin', annotationPin)
  .directive('taskListItem', taskListItem)
  .directive('approvalListItem', approvalListItem)
  .directive('shareArtButton', shareArtButton)
  .directive('copyGuestLink', copyGuestLinkDirective)
  .directive('commentReactionItem', CommentReactionItemDirective)
  .directive('floatingBarDelete', floatingBarDelete)
  .directive('warningCaption', warningCaption)
  .directive('userActionCard', userActionCard)
  .directive('miaLandingPageLayout', miaLandingPageLayout)
  .directive('onboardingTwoFeatureDialog', onboardingTwoFeatureDialog)
  .directive('onboardingDialog', onboardingDialog)
  .directive('dragAndDrop', dragAndDrop)
  .directive('advancedFilter', advancedFilter)

export const coreModule = module
